module.exports = __webpack_public_path__ + "img/arrow-left.cabd05eb.svg";